const ITEMS = [
  "Tools Built From Real Jobsite Problems",
  "Proxima Centauri Tools",
  "PrePipe Station — In Development",
  "A New American Tool Company",
];

const Row = () => (
  <div className="flex shrink-0 items-center">
    {ITEMS.map((item, i) => (
      <span key={i} className="flex items-center">
        <span className="whitespace-nowrap px-10 font-display text-4xl font-medium uppercase tracking-wide text-steel/25 md:text-6xl">
          {item}
        </span>
        <svg width="18" height="16" viewBox="0 0 18 16" className="shrink-0" aria-hidden="true">
          <path d="M9 1 L17 15 H1 Z" fill="none" stroke="#E60000" strokeWidth="1.4" />
        </svg>
      </span>
    ))}
  </div>
);

const Marquee = () => (
  <div
    data-testid="brand-marquee"
    className="relative overflow-hidden border-y border-white/10 bg-coal py-8"
    aria-hidden="true"
  >
    <div className="marquee-track flex w-max">
      <Row />
      <Row />
    </div>
  </div>
);

export default Marquee;
